<template>
    <div class="container">
        <UserNavigation/>
        <div class="text-wrapper">
            <h2>Zaštita privatnosti</h2>
            <p>U ime Udruženje gradjana "OLIVIA", Nikite Tolstoja 35, Vršac obavezujemo se da ćemo čuvati privatnost svih naših kupaca. Prikupljamo samo neophodne, osnovne podatke o kupcima/korisnicima i podatke neophodne za poslovanje i informisanje korisnika u skladu sa dobrim poslovnim običajima i u cilju pružanja kvalitetne usluge. Svi podaci o korisnicima/kupcima se strogo čuvaju.</p>
        </div>
    </div>
</template>

<script>
import UserNavigation from '../UserNavigation'

export default {
    name: 'PrivacyProtection',
    components: {
        UserNavigation
    }
}
</script>

<style scoped>
* {
    background: #F0EAD6;
}

.text-wrapper {
    margin-top: 20px;
}

h2 {
    font-weight: bold;
}

p {
    font-size: 1.2rem;
}

ol {
    font-size: 1.2rem;
    margin-left: 5%;
}

ul {
    font-size: 1.2rem;
    margin-left: 8%;
}

</style>